// components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const serviceLinks = [
    'Emergency Water Extraction',
    'Structural Drying',
    'Mold Remediation',
    'Water Damage Repair',
    'Flood Cleanup',
    'Sewage Cleanup',
    'Pipe Burst Repair',
    'Storm Damage Restoration'
  ];

  const quickLinks = [
    { name: 'Home', id: 'home' },
    { name: 'Services', id: 'services' },
    { name: 'About', id: 'about' },
    { name: 'Contact', id: 'contact' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo" onClick={() => scrollToSection('home')}>
              <span className="footer-logo-icon">💧</span>
              <span className="footer-logo-text">Water<span className="footer-logo-highlight">Damage</span></span>
              <span className="footer-logo-badge">Pro</span>
            </div>
            <p className="footer-brand-description">
              Your trusted water damage restoration experts serving homes and businesses across the USA. 
              Certified, insured, and available 24/7 for all your restoration needs.
            </p>
            <div className="footer-social">
              <a href="#" className="footer-social-link" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" className="footer-social-link" aria-label="Twitter">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="#" className="footer-social-link" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </a>
              <a href="#" className="footer-social-link" aria-label="YouTube">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-list">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={`#${link.id}`} 
                    className="footer-link"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.id);
                    }}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="footer-links">
            <h4 className="footer-heading">Our Services</h4>
            <ul className="footer-list">
              {serviceLinks.map((service, index) => (
                <li key={index}>
                  <a 
                    href="#services" 
                    className="footer-link"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('services');
                    }}
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="footer-heading">Contact Info</h4>
            <ul className="footer-list">
              <li className="footer-contact-item">
                <span className="footer-contact-icon">📞</span>
                <div>
                  <span className="footer-contact-label">Call 24/7</span>
                  <a href="tel:+1 (833) 493-6236" className="footer-contact-link">+1 (833) 493-6236</a>
                </div>
              </li>
              <li className="footer-contact-item">
                <span className="footer-contact-icon">✉️</span>
                <div>
                  <span className="footer-contact-label">Email Us</span>
                  <a href="mailto:info@waterdamagepro.com" className="footer-contact-link">info@waterdamagepro.com</a>
                </div>
              </li>
              <li className="footer-contact-item">
                <span className="footer-contact-icon">📍</span>
                <div>
                  <span className="footer-contact-label">Service Area</span>
                  <span className="footer-contact-text">Serving All USA</span>
                </div>
              </li>
              <li className="footer-contact-item">
                <span className="footer-contact-icon">🕐</span>
                <div>
                  <span className="footer-contact-label">Hours</span>
                  <span className="footer-contact-text">24/7 Emergency Service</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} <strong>WaterDamagePro</strong> — All Rights Reserved.
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy" className="footer-bottom-link">
                Privacy Policy
              </Link>
              <span className="footer-bottom-divider">|</span>
              <Link to="/terms-of-service" className="footer-bottom-link">
                Terms of Service
              </Link>
              <span className="footer-bottom-divider">|</span>
              <a href="#" className="footer-bottom-link">Sitemap</a>
            </div>
          </div>
          <p className="footer-disclaimer">
            Calls will be answered by a licensed restoration professional. Neither this site nor 
            anyone who answers the call receives a commission or fee dependent upon which 
            restoration provider a visitor may ultimately choose.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;